import React, { useEffect, useState } from 'react'
import classes from './TableInput.module.scss'
import { useForm, Controller } from 'react-hook-form'
import Select from 'react-select'
import {DoctorService} from "../../api/DoctorService";


const TableInput = ({onChange, setOutPutTable}) => {

  const [props, setProps] = useState({
    "doc":'',
    "lab":''
  })

  const [math, setMath] = useState({
    "summIn30": 0,
    "summIn3160": 0,
    "ever30": 0,
    "ever3160": 0,
    "ever60": 0
  })

  const {
    register,
    handleSubmit,
    control,
    watch
  } =useForm()

  const doc = []
  const lab = []

  const workersHandler =async()=>{
    await DoctorService.getAllWorkersByRole().then(res=>{
        if(res?.data){
            res?.data.doctor.map(docs=>{
            let obj = {
                "value": docs.name,
                "label": docs.name,
                "id":docs.id,
                "type": 'option'
            }
            doc.push(obj)
          })
            res?.data.laboratoryAssistant.map(labo=>{
            let obj = {
                "value": labo.name,
                "label": labo.name,
                "id":labo.id,
                "type": 'option'
            }
            lab.push(obj)
        })
        }
        setProps({
          "doc":doc,
          "lab":lab
        })
    })
  } 

  useEffect(()=>{
    if(props.doc == ''){
    workersHandler()
    }
  },[props]) 

  const closeButton = () => {
    onChange(false)
  }

  const onSubmit = (data) => {
    onChange(false)
    setOutPutTable({
      ...data,
      "summIn30": math.summIn30,
      "summIn3160": math.summIn3160,
      "ever30": math.ever30,
      "ever3160": math.ever3160,
      "ever60": math.ever60,
      "Doc": data.Doc.id,
      "Labor": data.Labor.id,
    })
  }

  let table = [
    {
          "legend1": '№',
          "legend2": 'Кількість сигналів',
          "props": [1,2,3,4,5,6,7,8,9,10]
    },
    {
          "legend1": '№',
          "legend2": 'Кількість сигналів',
          "props": [11,12,13,14,15,16,17,18,19,20]
    },
    {
          "legend1": '№',
          "legend2": 'Кількість сигналів',
          "props": [21,22,23,24,25,26,27,28,29,30]
    },
    {
        "legend1": '№',
        "legend2": 'Кількість сигналів',
        "props": [31,32,33,34,35,36,37,38,39,40]
    },
    {
        "legend1": '№',
        "legend2": 'Кількість сигналів',
        "props": [41,42,43,44,45,46,47,48,49,50]
    },
    {
        "legend1": '№',
        "legend2": 'Кількість сигналів',
        "props": [51,52,53,54,55,56,57,58,59,60]
    }
  ]

  useEffect(()=>{
    const { unsubscribe } = watch((value) => {
      const tableOutput = value
      let under30 = 0
      let upper30 = 0
      for(let i = 1; i <=30;i++){
        under30 += +(tableOutput[i])
      }
      for(let i = 31; i <=60;i++){
        upper30 += +(tableOutput[i])
      }
      let averageD30 = Math.ceil(under30/30)
      let averageP30 = Math.ceil(upper30/30)
      let average = Math.ceil((upper30 + under30)/60)
      document.querySelector('[name="summIn30"]').value = under30
      document.querySelector('[name="summIn3160"]').value = upper30
      document.querySelector('[name="ever30"]').value = averageD30
      document.querySelector('[name="ever3160"]').value = averageP30
      document.querySelector('[name="ever60"]').value = average
      setMath({
        "summIn30": under30,
        "summIn3160": upper30,
        "ever30": Math.ceil(under30/30),
        "ever3160": Math.ceil(upper30/30),
        "ever60": Math.ceil((upper30 + under30)/60)
      })
    })
    return () => unsubscribe()
  },[watch])

  return (
    <div className={classes.container}>
        <button onClick={closeButton} className={classes.closeButton}>
            X
        </button>       
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}> 
          <legend className={classes.form__legend}>ДОДАТОК до цитогенетичного дослідження карциноми грудної залози методом CISH</legend>
          <div className={classes.form__table}>
            {table.map(el=>(
              <div className={classes.form__table}>
                <div className={classes.form__table__container}>
                  <div className={classes.form__table__box}>
                    <legend className={classes.form__table__legend}>{el.legend1}</legend>
                    <legend className={classes.form__table__legend}>{el.legend2}</legend>
                  </div>
                  {el.props.map(props=>(
                    <div className={classes.form__table__box}>
                      <label className={classes.form__table__label}>{props}</label>
                      <input className={classes.form__table__input} type='number' {...register(`${props}`)}/>
                    </div>
                  ))}
                </div> 
              </div>   
            ))}
          </div>
          <div className={classes.form__table}>
            <div className={classes.form__table__box}>
              <div className={classes.form__table__container}>
                <div className={classes.form__table__box__sum}>
                  <label className={classes.form__table__label__sum}>Сума сигналів 31-60 клітинах</label>
                  <input className={classes.form__table__input__sum} {...register('summIn3160')}/>
                </div>
                <div className={classes.form__table__box__sum}>
                  <label className={classes.form__table__label__sum}>Середня кількість сигналів 31-60 клітинах</label>
                  <input className={classes.form__table__input__sum} {...register('ever3160')}/>
                </div>
              </div>
            </div>
            <div className={classes.form__table__box}>
              <div className={classes.form__table__container}>
                <div className={classes.form__table__box__sum}>
                  <label className={classes.form__table__label__sum}>Сума сигналів у 30 клітинах</label>
                  <input className={classes.form__table__input__sum} {...register('summIn30')}/>
                </div>
                <div className={classes.form__table__box__sum}>
                  <label className={classes.form__table__label__sum}>Середня кількість сигналів у 30 клітинах</label>
                  <input className={classes.form__table__input__sum} {...register('ever30')}/>
                  </div>
                </div>
            </div>
          </div>
          <div className={classes.form__table__box__sum}>
            <label className={classes.form__table__label__sum}>Середня кількість сигналів у 60 клітинах</label>
            <input className={classes.form__table__input__sum} {...register('ever60')}/>
          </div>
          <div className={classes.form__table__concl}>
            <p className={classes.form__table__label}>Шкала оцінювання CISH:</p>
            <p className={classes.form__table__label}>- Ампліфікація відсутня (1-5 сигналів/ядро пухлинної клітини)</p>
            <p className={classes.form__table__label}>- Ампліфікація є ( більше 5 сигналів/ядро пухлинної клітини)</p>
          </div>
          <div className={classes.form__table__concl}>
            <div className={classes.form__table__box}>
              <input type="radio" id="ampl" value='ampl' {...register('ampl')}/>
              <label className={classes.form__table__label} for="ampl">HER2 неампліфікований (меньше 5)</label>
            </div>
            <div className={classes.form__table__box}>
              <input type="radio" id="notAmpl" value='notAmpl'  {...register('ampl')}/>
              <label className={classes.form__table__label} for="notAmpl">HER2 неампліфікований (більше 5)</label>
            </div>
          </div>
          <div className={classes.form__table__container__concl}>
            <Controller
              control={control}
              name='Doc'
              render={({field: {onChange, value}}) => (
                <Select
                  className={classes.select}
                  options={props.doc}
                  value={value ? value : []}
                  onChange={onChange}
                  required
                  disableSearch
                  hasSelectAll={false}
                  placeholder='Виберіть лікаря...'
                />
              )}
            />
            <Controller
              control={control}
              name='Labor'
              render={({field: {onChange, value}}) => (
                <Select
                  className={classes.select}
                  options={props.lab}
                  required
                  value={value ? value : []}
                  onChange={onChange}
                  disableSearch
                  hasSelectAll={false}
                  placeholder='Виберіть лаборанта...'
                />
              )}
            />
            
            <div className={classes.form__table__box}>
              <label className={classes.form__table__label}>Дата:</label>
              <input className={classes.form__table__input} required type='date' {...register('date')}/>
            </div>
          </div>
          <button className={classes.form__button} type='submit'>
              Додати
          </button>
        </form>
    </div>
  )
}

export default TableInput